import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';

import TeacherFormView from './view';
import { closeModal } from 'actions/modal';

import { USER_CONFIG, BATCHES_CONFIG } from 'constants/api';
import { FORM_ACTIONS, USER_TAB } from 'constants/form';

class TeacherForm extends PureComponent {
  constructor(props) {
    super(props);
    const { data, formType, tab, hideSlot } = this.props;
    this.state = {
      formType: formType || FORM_ACTIONS.CREATE,
      tab: tab || USER_TAB.ACCOUNT,
      teacher: data,
      message: null,
      isFirst: true,
      hideSlot: hideSlot ? true : false,
      isLast: tab === Object.keys(USER_TAB).length - 1,
    };
  }

  changeTab = ({ tab, type, data, message }) => {
    const { actions } = this.props;
    const { tab: lastTab, formType, teacher } = this.state;
    const newTab = tab === 0 ? 0 : tab || lastTab;

    if (tab < 0 || tab >= Object.keys(USER_TAB).length) {
      actions.closeModal();
      return;
    }
    this.setState({
      tab: newTab,
      formType: type || formType,
      teacher: data || teacher,
      message: message || null,
      isFirst: newTab === 0,
      isLast: newTab === Object.keys(USER_TAB).length - 1,
    });
  };

  render() {
    const { userConfig, batchConfig, programs, fromSeeSlots } = this.props;

    return (
      <TeacherFormView
        {...this.state}
        fromSeeSlots={fromSeeSlots}
        userConfig={userConfig}
        batchConfig={batchConfig}
        programs={programs}
        onNavigate={this.changeTab}
      />
    );
  }
}

export default connect(
  ({ configs, programs }) => ({
    userConfig: store.get(configs, USER_CONFIG).data,
    batchConfig: store.get(configs, BATCHES_CONFIG).data,
    programs: store.getAll(programs).data,
  }),
  dispatch => ({
    actions: bindActionCreators({ closeModal }, dispatch),
  }),
)(TeacherForm);
